import { render, staticRenderFns } from "./GeneralTermsAndConditions.vue?vue&type=template&id=5cce65ce&"
import script from "./GeneralTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./GeneralTermsAndConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports